import * as React from "react";

export const SvgFreight = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<mask
			id="a"
			style={{
				maskType: "luminance",
			}}
			maskUnits="userSpaceOnUse"
			x={0}
			y={0}
			width={20}
			height={20}
		>
			<path d="M18.9 18.9V1.1H1.1v17.8h17.8Z" fill="#fff" stroke="#fff" strokeWidth={1.2} />
		</mask>
		<g
			mask="url(#a)"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.2}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M17.459 17.459a1.484 1.484 0 1 1-2.969 0 1.484 1.484 0 0 1 2.969 0ZM9.295 17.459a1.484 1.484 0 1 1-2.969 0 1.484 1.484 0 0 1 2.969 0Z" />
			<path d="M18.943 13.748H4.842v2.227h14.101v-2.227ZM1.057 1.057h2.3c.82 0 1.485.664 1.485 1.484v11.207M17.459 7.068H7.069v6.68h10.39v-6.68Z" />
			<path d="M15.975 1.873H8.553v5.195h7.422V1.873Z" />
			<path d="M13.377 1.873H11.15V4.1h2.227V1.873ZM13.748 7.068h-2.969v2.97h2.969v-2.97Z" />
		</g>
	</svg>
);
